import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MacLogo',
  props: {
  height: {
    type: Number,
    default: 38
  },
  color: {
    type: String,
    default: 'white'
  },
  maskColor: {
    type: String,
    default: '#333333'
  }
},
  setup(__props) {

const props = __props;



const height = computed(() => props.height)
const color = computed(() => props.color)
const maskColor = computed(() => props.maskColor)
const width = computed(() => height.value * 80/ 38)

return { __sfc: true,props, height, color, maskColor, width }
}

})